import React from 'react';
import SignupForm from '../signup-form';
import { mergeMarketingAttributionFromLocation } from '../../../../shared/utils/gtm-attribution';
import { IProps, IState } from './types';

class Signup extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);
    this.showSignUpQuestionsComponent = this.showSignUpQuestionsComponent.bind(
      this,
    );
  }

  componentDidMount() {
    mergeMarketingAttributionFromLocation();
  }

  showSignUpQuestionsComponent() {
    const { history } = this.props;

    history.push('/warmup');
  }

  render() {
    return <SignupForm />;
  }
}

export default Signup;
